import { writable } from 'svelte/store'

// Seeded by AppLayout from Inertia shared props on every navigation.
// Components that need the sidebar property list can subscribe here
// instead of drilling through page props.
export const propertiesStore = writable([])
